import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./Redux/store";
import { BrowserRouter } from "react-router-dom";
import { PostHogProvider } from "posthog-js/react";
import StripeSessionGuard from "./guards/StripeSessionGuard";

const options = {
  api_host: 'https://us.i.posthog.com',
};

ReactDOM.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey="phc_Dj0R59t2W7hmdc5Z6Qf06zAyJiokHAj8pZRlQSMUot0"
      options={options}
    >
      <Provider store={store}>
        <BrowserRouter>
          <StripeSessionGuard />
          <App />
        </BrowserRouter>
      </Provider>
    </PostHogProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
